import { render } from "./PrivacyAgreement.vue?vue&type=template&id=7e16be2c&scoped=true"
import script from "./PrivacyAgreement.vue?vue&type=script&lang=js"
export * from "./PrivacyAgreement.vue?vue&type=script&lang=js"

import "./PrivacyAgreement.vue?vue&type=style&index=0&id=7e16be2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e16be2c"]])

export default __exports__